exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxtbiz-dept-tree[data-v-3b892912]{height:100%}.yxtbiz-dept-tree-radio[data-v-3b892912]{overflow:hidden;display:inline-block;vertical-align:bottom;width:20px}\n", ""]);

